<template>
<div>
     <pt-page-factor-filter :labels="filterLabels" v-model="filterCondition">
        <template>
            <el-button type="primary" @click="Filter">筛选</el-button>
            <!-- <el-button type="text" @click="cleanParams">清除筛选条件</el-button> -->
          </template>
      </pt-page-factor-filter>
    <!-- <pt-page-menu-filter :tabs="groupTabs" v-model="selectTab" label-name="name" value-name="id" :is-route-query="false" @select="selectTabs"></pt-page-menu-filter> -->
    <template v-if="selectType=='radio'">
        <pt-radio-list :page-size="pageSize" :table-data="tableData" :tableLabels="tableLabels" :selectRow="selectedGoods"  @getTableData="getTableData" subFiled="goodsDTO"
    subSecondFiled="goodsData" subOnlyFiled="goodsDTO"  :total-count="totalCount" @selected="selected" ref="table" ></pt-radio-list>
    <div class="button-div" v-if="isRadioSelectButton">
            <el-button type="primary" @click="submit">选择</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
    </template>
    <template v-else>
        <pt-select-list :page-size="pageSize" :tableLabels="tableLabels"  @getTableData="getTableData" :total-count="totalCount" :table-data="tableData" :keys="['goodsDTO','goodsData','goodsId']"
        :showName="['goodsDTO','goodsData','name']" @selected="selected" :loading="loading" :selectedRows="selectRow" :isSelect="isSelect" ref="table" >
        <slot slot="before" name="before"/>
        </pt-select-list>
        <div class="button-div" v-if="isSelectButton">
            <el-button type="primary" @click="submit">选择</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </template>
</div>
</template>
<script>
import ptSelectList from 'cps/base/pt-select-list'
import ptRadioList from 'cps/base/pt-radio-list'
import { selectGoodsTableLabels } from 'json/mall-options'
import { goodsSelectFactorFileterLables } from './mall-options'
import { cashCount, isEmptyObject } from '@/utils/formUtils'
export default {
  props: {
    pageSize: {
      type: Number,
      default: 6
    },
    selectedGoods: {
      type: [Array, Object],
      default: function () {
        return []
      }
    },
    isSelect: {
      type: Boolean,
      default: true
    },
    isSelectButton: {
      type: Boolean,
      default: true
    },
    isRadioSelectButton: {
      type: Boolean,
      default: false
    },
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    },
    goodsBelong: {
      type: String,
      default: null
    },
    selectType: {
      type: String,
      default: 'select'
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disableArr: Array,
    required: Boolean
  },
  components: {
    ptSelectList,
    ptRadioList
  },
  computed: {
    filterLabels () {
      goodsSelectFactorFileterLables.forEach(item => {
        if (this.disableArr && this.disableArr.length) {
          this.disableArr.forEach(etem => {
            if (item.value === etem) {
              item.disabled = true
            }
          })
        }
      })
      return goodsSelectFactorFileterLables
    }
  },
  data () {
    return {
      totalCount: 0,
      tableLabels: selectGoodsTableLabels,
      page_size: this.pageSize,
      tableData: [],
      groupTabs: [],
      selectTab: '',
      selectRow: JSON.parse(JSON.stringify(this.selectedGoods)),
      isChangePage: false,
      // filterLabels: goodsSelectFactorFileterLables,
      filterCondition: JSON.parse(JSON.stringify(this.params)),
      paramsData: JSON.parse(JSON.stringify(this.params)),
      loading: false,
      goodsTypeList: []
    }
  },
  watch: {
    groupList: {
      handler: function (val) {
        if (val.length > 0) {
          let data = JSON.parse(JSON.stringify(val))
          this.filterLabels.forEach(item => {
            if (item.value === 'groupId') {
              item.options = data
            }
          })
          this.groupTabs = data
          this.selectTab = data[0].id
        } else {
          this.getGroupList()
        }
      },
      deep: true,
      immediate: true
    },
    goodsTypeList: {
      handler: function (val) {
        if (val.length > 0) {
          let data = JSON.parse(JSON.stringify(val))
          this.filterLabels.forEach(item => {
            if (item.value === 'type') {
              item.options = data
            }
          })
        }
      }
    },
    groupTabs (val) {
      this.filterLabels.forEach(item => {
        if (item.value === 'groupId') {
          item.options = val
        }
      })
    }
  },
  methods: {
    Filter () {
      for (var key in this.filterCondition) {
        if (!this.filterCondition[key]) {
          this.$delete(this.filterCondition, key)
        }
        if (key === 'priceInterval') {
          this.filterCondition.priceIntervalMax = cashCount(this.filterCondition[key].priceIntervalMax)
          this.filterCondition.priceIntervalMin = cashCount(this.filterCondition[key].priceIntervalMin)
          this.$delete(this.filterCondition, key)
        } else if (key === 'publishTime') {
          this.filterCondition = { ...this.filterCondition, ...this.filterCondition[key] }
          this.$delete(this.filterCondition, key)
        }
      }
      this.paramsData = JSON.parse(JSON.stringify(this.filterCondition))
      //   this.getTableData(0).then(this.$refs.table.reset())
      this.$refs.table.reset()
    },
    selectTabs (val) {
      this.selectTab = val
      this.getTableData(0)
    },
    selected (val) {
      this.selectRow = JSON.parse(JSON.stringify(val))
      this.$emit('selectMealRow', val)
    },
    cancel () {
      this.$emit('close')
    },
    submit () {
      if (this.required) {
        if (this.selectRow) {
          if (Object.prototype.toString.call(this.selectRow) === '[object Array]') {
            if (this.selectRow.length) {
              this.$emit('selectGoodsSubmit', JSON.parse(JSON.stringify(this.selectRow)))
            } else {
              this.$message.error('请至少选择一个商品')
            }
          } else if (Object.prototype.toString.call(this.selectRow) === '[object Object]') {
            if (!isEmptyObject(this.selectRow)) {
              this.$emit('selectGoodsSubmit', JSON.parse(JSON.stringify(this.selectRow)))
            } else {
              this.$message.error('请选择商品')
            }
          }
        } else {
          this.$message.error('请选择商品')
        }
      } else {
        this.$emit('selectGoodsSubmit', JSON.parse(JSON.stringify(this.selectRow)))
      }
    },
    handleCurrentChange (page) {
      this.isChangePage = true
    },
    getGroupList () {
      let data = {
        example: {},
        pageable: {
          page: 0,
          size: 99999
        }
      }
      this.loading = true
      this.$store.dispatch('getGoodsGroup', data).then(res => {
        this.loading = false
        this.groupTabs = res.data
        this.selectTab = res.data[0].id
        this.getTableData(0)
      }).catch(err => {
        this.loading = false
        this.$message(err || '获取商品分组列表失败')
      })
    },
    // 获取商品类型列表
    getGoodsTypes () {
      this.$store.dispatch('getGoodsTypes').then(res => {
        this.goodsTypeList = res
      }).catch(err => {
        this.$message.error(err || '获取商品类型失败')
      })
    },
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        state: 'PUBLISHED',
        // goodsDTO: {
        //   goodsData: {

        //     // groupId: this.selectTab,
        //     // goodsBelong: this.goodsBelong
        //   },

        // },
        pageable: {
          page: page,
          size: this.page_size,
          sort: ['putOnSaleTime,desc', 'id,desc']
        }
      }
      if (next) {
        this.loading = true
      }

      return this.$store.dispatch('goodsSort', data).then(res => {
        if (next) {
          next(res.data)
        } else {
          this.tableData = res.data
        }
        this.totalCount = res.totalNumber
        this.loading = false
      }).catch(err => {
        this.loading = false
        // this.$refs.tabelPage.showReTry()
        this.$message.error(err || '获取商品列表失败')
      })
    }
  },
  created () {
    this.getGoodsTypes()
    if (this.selectedGoods && this.selectedGoods.length > 0) {
    }
    if (!this.$store.getters.showStockQuantity) {
      this.tableLabels.forEach((item, index) => {
        if (item.label === '库存') {
          this.tableLabels.splice(index, 1)
        }
      })
    }
    // this.getGroupList()
  }
}
</script>
<style module lang="less">
</style>
